import { Button } from '@ferris/react/components/button';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { connect } from 'react-redux';
import { Loader } from '@ferris/react';
import TranslationUtil from '../../../utils/TranslationUtil';
import { UserCtx } from '../../../contexts/user';
import { JoinCtx } from '../../../contexts/join';

export const DetailsSubmitButton = (props) => {
    const {
        buttonNextLabel,
        paperContractNextLabel,
        competitorUrlLoading,
        isFormDataValid,
        handleSubmit
    } = props;
    const [submitting, setSubmitting] = useState(false);

    const {
        paperContractUser,
        loading
    } = useContext(UserCtx);
    const {
        loading: joinLoading
    } = useContext(JoinCtx);

    const onClick = () => {
        setSubmitting(true);
        if (isFormDataValid()) {
            handleSubmit();
        }
    };

    const label = paperContractUser ? paperContractNextLabel : buttonNextLabel;

    return (
        <div className="property_details__bottom">
            <Button
                isFullWidth
                classes="property_details__bottom"
                htmlButtonType="button"
                type="primary"
                data-wdio="next-button"
                id="propertyInfoNextBtn"
                onClick={onClick}
                disabled={!isFormDataValid()
                    || competitorUrlLoading
                    || loading
                    || joinLoading
                    || submitting
                }
            >
                { (competitorUrlLoading || loading || joinLoading || submitting) ? (
                    <Loader
                        inline
                        size="mini"
                        visible
                        title={label}
                    />
                ) : (<>{label}</>)}
            </Button>
        </div>
    );
};

DetailsSubmitButton.propTypes = {
    buttonNextLabel: PropTypes.string.isRequired,
    paperContractNextLabel: PropTypes.string.isRequired,
    competitorUrlLoading: PropTypes.bool.isRequired,
    isFormDataValid: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired
};

const mapStateToProps = (state) => {
    const { app } = state;
    const { competitorUrlLoading } = state.joinDetails;
    const translations = new TranslationUtil(app.translations, app.fallbackTranslations);
    return {
        competitorUrlLoading,
        buttonNextLabel: translations.getTranslation('Vrbo.cta.next'),
        paperContractNextLabel: translations.getTranslation('property.paperContract.agree')
    };
};

export default connect(mapStateToProps)(DetailsSubmitButton);
